import { render } from "./GiftcardDeliverytypeSelector.vue?vue&type=template&id=44f6dec3"
import script from "./GiftcardDeliverytypeSelector.vue?vue&type=script&lang=js"
export * from "./GiftcardDeliverytypeSelector.vue?vue&type=script&lang=js"

import "./GiftcardDeliverytypeSelector.vue?vue&type=style&index=0&id=44f6dec3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__